import { IDBEntityCacheStore } from "./IDBEntityCacheStore";
import { Timeouts } from "@gap/utils/date-utils";
import { apiClientSilent } from "api/trpc/trpc-client";
import { ProcessFavoriteDto } from "@gap/backend/app-services/process-favorite/models/ProcessFavoriteDto";

export class IDBFavoriteProcessesCache {
   static get = async (options?: { favoriteType?: ProcessFavoriteDto.FavoriteType, force?: boolean }): Promise<ProcessFavoriteDto.Entity[]> => {
      return await IDBFavoriteProcessesCache.cache(options?.favoriteType).fetch(options?.force) || []
   }

   static invalidate = async (favoriteType?: ProcessFavoriteDto.FavoriteType) => {
      await IDBFavoriteProcessesCache.cache(favoriteType).invalidate()
   }

   private static cache = (favoriteType?: ProcessFavoriteDto.FavoriteType | undefined) => {
      const query = favoriteType ? { favoriteType } : undefined
      return new IDBEntityCacheStore<ProcessFavoriteDto.Entity[]>({
         entityKey: `process-favorites-${favoriteType}`,
         fetcher: () => apiClientSilent.processFavorite.getFavorites.query(query),
         cacheOptions: {
            ttlMs: Timeouts.minute * 30
         }
      })
   }
}
